import { v4 as uuidv4 } from 'uuid';
import { ExtensionActionIdSchema, ExtensionFieldIdSchema, ExtensionIdSchema, ExtensionRuleIdSchema, } from '../extension.js';
/**
 * Generate a new extension ID with proper branding and prefix
 *
 * @example
 * generateExtensionId(); // => "ext_123e4567-e89b-12d3-a456-426614174000"
 */
export function generateExtensionId() {
    const id = `ext_${uuidv4()}`;
    return ExtensionIdSchema.parse(id);
}
/**
 * Generate a new field ID with proper branding and prefix
 *
 * @example
 * generateFieldId(); // => "field_123e4567-e89b-12d3-a456-426614174000"
 */
export function generateExtensionFieldId() {
    const id = `field_${uuidv4()}`;
    return ExtensionFieldIdSchema.parse(id);
}
/**
 * Generate a new action ID with proper branding and prefix
 *
 * @example
 * generateActionId(); // => "action_123e4567-e89b-12d3-a456-426614174000"
 */
export function generateExtensionActionId() {
    const id = `action_${uuidv4()}`;
    return ExtensionActionIdSchema.parse(id);
}
/**
 * Generate a new fulfillment-constraint rule ID with proper branding and prefix
 *
 * @example
 * generateExtensionRuleId(); // => "rule_123e4567-e89b-12d3-a456-426614174000"
 */
export function generateExtensionRuleId() {
    const id = `rule_${uuidv4()}`;
    return ExtensionRuleIdSchema.parse(id);
}
//# sourceMappingURL=utils.js.map